import communicationIntroPNG from '~/assets/images/communication/intro.png'
import communicationIntroWEBP from '~/assets/images/communication/intro.webp'

export { communicationIntroPNG, communicationIntroWEBP }

export const INTRO_ACCENT_COLOR = '#096EF9'
